import isServer from "./isServer";

export function setCookie(name, value, expirationTime) {
  if (!isServer()) {
    let expires = "";
    if (expirationTime) {
      const date = new Date();
      date.setTime(date.getTime() + expirationTime);
      expires = "; expires=" + date.toGMTString();
    }
    document.cookie = name + "=" + value + expires + "; path=/";
  }
}

/**
 * Deletes all cookies on logout.
 * @param {String} name
 * @returns {Boolean}
 * @public
 */
export function deleteAllCookies() {
  var cookies = document.cookie.split(";");

  for (var i = 0; i < cookies.length; i++) {
    var cookie = cookies[i];
    var eqPos = cookie.indexOf("=");
    var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
    document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
  }
}
/**
 * Gets cookie value for a given cookie name from the browser.
 * @param {String} name - Cookie name.
 * @returns {String} Cookie value.
 * @public
 */
export function getCookieByName(name) {
  const value = "; " + document.cookie;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2)
    return parts
      .pop()
      .split(";")
      .shift();
}

/**
 * Deletes the cookie value for a given cookie name from the browser.
 * @param {String} name - Cookie name.
 * @public
 */

export function deleteCookieByName(name) {
  const d = new Date(); // Create an date object
  d.setTime(d.getTime() - 1000 * 60 * 60 * 24); // Set the time to the past. 1000 milliseonds = 1 second
  const expires = "expires=" + d.toGMTString(); // Compose the expirartion date
  window.document.cookie = `${name}=; path=/; ${expires}`; // Set the cookie with name and the expiration date
}
